import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    userOccupationTitle: Yup.string().required('Required').nullable(),
  });
